import { Col, Container, Row } from 'react-bootstrap';
import NavBar from '../components/NavBar';
const NotFound = () => {
  return (
    <div>
      <NavBar />
      <h1>NOT FOUND BRADER</h1>
      <h1>NOT FOUND BRADER</h1>
      <h1>NOT FOUND BRADER</h1>
      <h1>NOT FOUND BRADER</h1>
      <h1>NOT FOUND BRADER</h1>
      <h1>NOT FOUND BRADER</h1>
      <h1>NOT FOUND BRADER</h1>
    </div>
  );
};

export default NotFound;
